import {matchPath} from 'react-router';

import {RoutePattern} from '@/shared/types/routes';

export function isOnTheSomeRoutePath(
  routes: readonly RoutePattern[],
  pathname: string
) {
  return routes.some((pattern) => matchPath(pattern, pathname) !== null);
}
